// Used in login-routing.module.ts

// Angular
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";

// RXJS/Store
import * as RouterStore from "#core/router-store";
import { Store, select } from "@ngrx/store";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as LoginStore from "../../store";

// Services/Types/Helpers
import { LocalStorage } from "#core/services";
import { ClassLinkLoginRequest } from "@carnegie-learning/data-access-angular-passport";

@Component({
    selector: "app-login-classlink",
    templateUrl: "./login-classlink.component.html",
    styleUrls: ["./login-classlink.component.scss"],
    standalone: false
})
export class LoginClassLinkComponent implements OnInit, OnDestroy {
    maintenanceMode: boolean = (<any>window).maintenanceMode;
    bannerStatus$?: Observable<boolean>;
    bannerMessage$?: Observable<string>;
    bannerColor$?: Observable<string>;
    showProgressSpinner = true;
    classLinkLogo = "./assets/images/login/classLink-logo.png";
    private ngUnsubscribe = new Subject();

    constructor(
        private router: Router,
        public loginStore: Store<LoginStore.UserState>,
        public routerStore: Store<RouterStore.State>,
        private localStorage: LocalStorage
    ) {}

    ngOnInit() {
        this.bannerStatus$ = this.loginStore.pipe(
            select(LoginStore.getLoginBannerStatus)
        );
        this.bannerMessage$ = this.loginStore.pipe(
            select(LoginStore.getLoginBannerMessage)
        );
        this.bannerColor$ = this.loginStore.pipe(
            select(LoginStore.getLoginBannerColor)
        );

        this.loginStore
            .pipe(select(LoginStore.getLoginBannerColor))
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
                if (data !== "primary") {
                    this.showProgressSpinner = false;
                }
            });

        if (this.maintenanceMode) {
            this.loginStore.dispatch(LoginStore.userLoginMaintenance());
            this.showProgressSpinner = false;
        } else {
            this.routerStore
                .pipe(select(RouterStore.getRouterState))
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe((data) => {
                    if (
                        data &&
                        data.state.url.includes("classlink/authorize")
                    ) {
                        let oAuthToken: string =
                            this.localStorage.get("oAuth2Code");

                        if (!oAuthToken) {
                            // backup if URL get's changes again
                            oAuthToken = data.state.queryParams.code;
                        }

                        // Clear out local storage and reset state
                        this.localStorage.clear();
                        this.loginStore.dispatch(
                            LoginStore.userProfileResetState()
                        );
                        this.loginStore.dispatch(
                            LoginStore.registerResetState()
                        );

                        if (oAuthToken === undefined || oAuthToken === null) {
                            this.loginStore.dispatch(
                                LoginStore.userClassLinkLoginNoToken()
                            );
                        } else {
                            const payload: ClassLinkLoginRequest = {
                                classLinkToken: oAuthToken,
                            };

                            this.loginStore.dispatch(
                                LoginStore.userClassLinkLoginAttempt({
                                    payload: payload,
                                })
                            );
                        }
                    }
                });
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }

    cancel() {
        this.router.navigate(["login/form"]);
    }
}
